import script from "./TariffList.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffList.vue?vue&type=script&setup=true&lang=js"

import "./TariffList.vue?vue&type=style&index=0&id=6e0e65f6&lang=scss"

const __exports__ = script;

export default __exports__